import { render, staticRenderFns } from "./AppAsideExternalLink.vue?vue&type=template&id=c49e7842"
import script from "./AppAsideExternalLink.vue?vue&type=script&lang=js"
export * from "./AppAsideExternalLink.vue?vue&type=script&lang=js"
import style0 from "./AppAsideExternalLink.vue?vue&type=style&index=0&id=c49e7842&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports